// Shared constants for Budget components
// This file centralizes all dropdown options to avoid duplication

export const STATE_OPTIONS = [
  { label: 'Enabled', value: 'enabled' },
  { label: 'Disabled', value: 'disabled' },
  { label: 'Draft', value: 'draft' },
  { label: 'Completed', value: 'completed' },
];

export const SETUP_FLOW_OPTIONS = [
  { label: 'Quick Setup', value: 'quick' },
  { label: 'Advanced Setup', value: 'advanced' },
];

export const AGENCY_INTERNAL_OPTIONS = [
  { label: 'Agency View', value: false },
  { label: 'Limitless View', value: true },
];

export const BUDGET_DRIVER_OPTIONS = [
  { label: 'Daily', value: 'daily' },
  { label: 'Monthly', value: 'monthly' },
];

export const AD_TYPE_CSV_OPTIONS = [
  { label: 'Sponsored Product and Sponsored Display', value: 'SP,SD' },
  { label: 'Sponsored Brand', value: 'SB' },
  { label: 'Sponsored Tv', value: 'ST' },
];

// AD Type groups for budget allocation - order matters!
export const AD_TYPE_GROUPS = [
  { label: 'SP + SD', value: 'SP,SD', key: 'sp_sd' },
  { label: 'SB', value: 'SB', key: 'sb' },
  { label: 'ST', value: 'ST', key: 'st' },
];

export const BUDGET_TYPE_OPTIONS = [
  { label: 'Strict Budget', value: 0 },
  { label: 'No Budget', value: 1 },
  { label: 'Flexible Budget', value: 2 },
];

export const INCLUDES_OPTIONS = [
  { label: 'All ADs', value: '' },
  { label: 'Limitless ADs', value: 'limitless' },
];

export const SPEND_PRIORITY_OPTIONS = [
  { label: 'Most Brand', value: '-2' },
  { label: 'More Brand', value: '-1' },
  { label: 'Brand and Non-Brand', value: '0' },
  { label: 'More NonBrand', value: '1' },
  { label: 'Most NonBrand', value: '2' },
];

export const SPEND_TACTIC_OPTIONS = [
  { label: 'Max Performance', value: 'max_perf' },
  { label: 'Full Budget Spend', value: 'full_spend' },
];

export const SPEND_SPEED_OPTIONS = [
  { label: 'Standard', value: 'speed_level_1' },
  { label: 'Fast', value: 'speed_level_2' },
  { label: 'Fastest', value: 'speed_level_3' },
];

export const COST_TARGET_TYPE_OPTIONS = [
  { label: 'Blended', value: 'blended' },
  { label: 'Brand/NonBrand', value: 'bnb' },
];

export const STATUS_OPTIONS = [
  { label: 'ON', value: 'ON' },
  { label: 'OFF', value: 'OFF' },
];

export const ACTIVE_DAY_OPTIONS = [
  { label: 'Monday', name: 'monday', value: '0' },
  { label: 'Tuesday', name: 'tuesday', value: '1' },
  { label: 'Wednesday', name: 'wednesday', value: '2' },
  { label: 'Thursday', name: 'thursday', value: '3' },
  { label: 'Friday', name: 'friday', value: '4' },
  { label: 'Saturday', name: 'saturday', value: '5' },
  { label: 'Sunday', name: 'sunday', value: '6' },
];
